module.exports = __webpack_public_path__ + "static/media/sharing-food.34ba9baf.svg";